"use strict";

exports.__esModule = true;
exports.createOptions = exports.formatTitle = void 0;

var _constants = _interopRequireDefault(require("../../common/constants"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var formatTitle = function formatTitle(title) {
  return title.replace(/_/g, ' ').split(' ').map(function (word) {
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }).join(' ');
};

exports.formatTitle = formatTitle;

var createOptions = function createOptions(constName) {
  return Object.entries(_constants["default"][constName]).map(function (_ref) {
    var title = _ref[0],
        value = _ref[1];
    return {
      value: value,
      title: formatTitle(title)
    };
  });
};

exports.createOptions = createOptions;